import { LogOutIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

interface LeaveOrganizationButtonProps {
  onClick: () => void
}

export const LeaveOrganizationButton: React.FC<LeaveOrganizationButtonProps> = ({
  onClick,
}): ReactNode => (
  <div className="leave-organization-section border-t pt-6">
    <Button
      variant="outline"
      onClick={onClick}
      className="leave-organization-button text-destructive hover:text-destructive"
    >
      <LogOutIcon className="mr-2 size-4" />
      Leave Organization
    </Button>
  </div>
)

LeaveOrganizationButton.displayName = 'LeaveOrganizationButton'
